<script setup>
import DepositButton from './DepositButton.vue'
import ShareButton from './ShareButton.vue'

const props = defineProps({
  wallet: {
    type: Object,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['deposit-method-selected', 'withdraw-requested'])

const handleDepositMethodSelected = (method) => {
  emit('deposit-method-selected', method)
}
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <div class="flex flex-col gap-3 w-full">
      <DepositButton
        :loading="loading"
        :always-expanded="true"
        @select-method="handleDepositMethodSelected"
      />

      <!-- Divider text -->
      <div v-if="wallet?.claimUrl && wallet?.emojiPin" class="text-center text-sm text-vault-text-secondary mt-2 mb-1">
        Or share with a friend to fund it
      </div>

      <ShareButton
        v-if="wallet?.claimUrl && wallet?.emojiPin"
        :claim-url="wallet.claimUrl"
        :emoji-pin="wallet.emojiPin"
        :wallet-address="wallet.address"
        :loading="loading"
      />
    </div>
  </div>
</template>

<style scoped>
/* No custom styles needed - all handled by Tailwind */
</style>
